function setContentAccordionPanelState(panel, isExpanded) {
  if (!panel) {
    return;
  }
  panel.removeAttribute('hidden');
  panel.setAttribute('aria-hidden', isExpanded ? 'false' : 'true');
  if ('inert' in panel) {
    panel.inert = !isExpanded;
  }
}

function syncContentAccordionPanels(root) {
  root.querySelectorAll('.content-accordion__item').forEach((it) => {
    const trigger = it.querySelector('.content-accordion__trigger');
    if (!trigger) {
      return;
    }
    const panelId = trigger.getAttribute('aria-controls');
    const panel = panelId ? document.getElementById(panelId) : null;
    if (!panel) {
      return;
    }
    setContentAccordionPanelState(panel, it.classList.contains('is-open'));
  });
}

function toggleContentAccordion(button, root) {
  const item = button.closest('.content-accordion__item');
  if (!item || !root.contains(item)) {
    return;
  }

  const panelId = button.getAttribute('aria-controls');
  const panel = panelId ? document.getElementById(panelId) : null;
  const wasOpen = item.classList.contains('is-open');

  root.querySelectorAll('.content-accordion__item').forEach((it) => {
    const trigger = it.querySelector('.content-accordion__trigger');
    if (!trigger) {
      return;
    }
    const pid = trigger.getAttribute('aria-controls');
    const p = pid ? document.getElementById(pid) : null;
    it.classList.remove('is-open');
    trigger.setAttribute('aria-expanded', 'false');
    setContentAccordionPanelState(p, false);
  });

  if (!wasOpen) {
    item.classList.add('is-open');
    button.setAttribute('aria-expanded', 'true');
    setContentAccordionPanelState(panel, true);
  }
}

function handleContentAccordionKeydown(event, root) {
  const key = event.key || event.code;
  if (key !== ' ' && key !== 'Enter') {
    return;
  }
  event.preventDefault();
  const button = event.target.closest('.content-accordion__trigger');
  if (button && root.contains(button)) {
    toggleContentAccordion(button, root);
  }
}

export function initContentAccordion() {
  document.querySelectorAll('.content-accordion').forEach((root) => {
    syncContentAccordionPanels(root);
    root.querySelectorAll('.content-accordion__trigger').forEach((button) => {
      button.addEventListener('click', () => {
        toggleContentAccordion(button, root);
      });
      button.addEventListener('keydown', (event) => {
        handleContentAccordionKeydown(event, root);
      });
    });
  });
}
